<template>
  <v-app>
    <v-container v-if="isSplash" fill-height>
      <v-row class="align-center">
        <v-img
          v-if="isSplash"
          contain
          transition="scale-transition"
          src="@/assets/logo.jpg"
          height="160"
          width="170"
        />
      </v-row>
    </v-container>
    <div v-else>
      <v-app-bar color="white" app elevate-on-scroll>
        <v-app-bar-nav-icon
          style="color: #848484"
          class="hidden-md-and-up"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-btn class="hidden-md-and-up" color="#848484" to="/" icon>
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <CategoriesMenu></CategoriesMenu>
        <v-spacer></v-spacer>

        <v-btn color="#848484" @click="showCart" icon>
          <v-badge
            color="red"
            left
            overlap
            :content="cartLineItemsCount"
            :value="cartLineItemsCount > 0"
          >
            <v-icon>mdi-cart</v-icon>
          </v-badge>
        </v-btn>
        <v-btn color="#848484" to="/MyDonations" icon>
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        <v-btn color="#848484" to="/Account" icon>
          <v-icon>mdi-account</v-icon>
        </v-btn>
        <v-btn
          color="#848484"
          v-if="isRegistered"
          :loading="isLoggingOut"
          @click="logOutDialog = true"
          icon
        >
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" temporary :right="isRight()" app>
        <!--         <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Title</v-list-item-title>
            <v-list-item-subtitle>subtitle</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item> -->
        <v-img contain src="@/assets/logo.jpg" height="100" />

        <v-divider></v-divider>

        <CategoriesListMenu></CategoriesListMenu>

        <template v-if="isRegistered" v-slot:append>
          <div class="pa-2">
            <v-btn :loading="isLoggingOut" @click="logOut" color="error" block
              >تسجيل الخروج</v-btn
            >
          </div>
        </template>
      </v-navigation-drawer>

      <v-dialog v-model="logOutDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"> تسجيل الخروج </v-card-title>
          <v-card-text>هل تريد تسجيل الخروج؟</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="logOutDialog = false">
              الغاء
            </v-btn>
            <v-btn color="red darken-1" text @click="logOut">
              تأكيد تسجيل الخروج
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <DonateComponent></DonateComponent>
      <v-content>
        <router-view></router-view>
      </v-content>
      <AppFooter></AppFooter>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import CategoriesMenu from "@/components/CategoriesMenu";
import CategoriesListMenu from "@/components/CategoriesListMenu";
import DonateComponent from "@/components/DonateComponent";
import AppFooter from "@/components/AppFooter";
export default {
  name: "App",
  components: {
    CategoriesMenu,
    CategoriesListMenu,
    DonateComponent,
    AppFooter
  },

  //********************** */
  data: () => ({
    drawer: false,
    isLoggingOut: false,
    isSplash: true,
    logOutDialog: false,
  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isLoggedIn: "isLoggedIn",
      language: "language",
      isRegistered: "isRegistered",
    }),
    ...mapGetters("Catalog", {
      categories: "categories",
    }),
    ...mapGetters("Cart", {
      cart: "cart",
    }),

    cartLineItemsCount: function () {
      return this.cart.lineItems == null ? 0 : this.cart.lineItems.length;
    },
  },
  //********************** */
  methods: {
    loadCategories: async function () {
      await this.$store.dispatch("Catalog/loadAllCategories");
    },
    signUpAnonymous: async function () {
      await this.$store.dispatch("Account/signUpAnonymous");
    },
    loadCart: async function () {
      await this.$store.dispatch("Cart/loadCart");
    },
    langaugeChanged(language) {
      if (language !== this.language) {
        this.$store.dispatch("Account/changeLanguage", language);
        this.$i18n.locale = this.language;
        if (this.language === "en") {
          this.$vuetify.rtl = false;
        } else {
          this.$vuetify.rtl = true;
        }
      }
    },
    isRight: function () {
      return this.language === "ar";
    },
    showCart: function () {
      this.$store.dispatch("Cart/showDonate");
    },

    logOut: async function () {
      this.isLoggingOut = true;
      this.logOutDialog = false;
      try {
        this.$store.dispatch("Account/logOut");
        await this.$store.dispatch("Account/signUpAnonymous");
        this.$store.dispatch("loadToken");
        await this.loadCart();
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoggingOut = false;
    },
  },

  //********************** */

  async mounted() {
    let self = this;
    setTimeout(function () {
      self.isSplash = false;
    }, 1500);

    this.$store.dispatch("loadToken");

    if (this.isLoggedIn) {
      await this.loadCart();
    } else {
      await this.signUpAnonymous();
      this.$store.dispatch("loadToken");
      await this.loadCart();
    }

    await this.loadCategories();
  },

  created() {
    this.$i18n.locale = this.language;
    if (this.language === "en") {
      this.$vuetify.rtl = false;
    } else {
      this.$vuetify.rtl = true;
    }
  },
};
</script>
<style >
.v-application .v-btn {
  letter-spacing: 0 !important;
}

.v-application .v-card-title {
  letter-spacing: 0 !important;
}

.v-application .v-card-text {
  letter-spacing: 0 !important;
}
.v-application h3 {
  letter-spacing: 0 !important;
}

/* .v-application .v-text-field {
   line-height:normal!important;
} */
</style>